import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'variableTypeget',
    standalone: false
})
export class VariableTypegetPipe implements PipeTransform {

  transform(value: number | string): boolean {
    return typeof value =='string' ? true : false
  }

}
